import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import draggable from 'vuedraggable'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'ZIndexModule',
  components: {
    draggable
  },
  data () {
    return {
      values: [],
      // 不要イベント対応
      dragInit: true,
      // draggable options
      draggableOptions: {
        draggable: '.item',
        filter: '.ignore'
      }
    }
  },
  mounted () {
    this.init()
    this.dragInit = true
  },
  beforeDestroy () {
    this.reset()
  },
  computed: {
    ...mapState({
      // const
      moduleType: state => state.screenConfigLayoutConst.moduleType,
      // module
      active: state => state.sclZIndexModule.active,
      // values
      originalValues: state => state.screenConfigLayout.values
    }),
    ...mapGetters({
      isSmartPhone: 'core/isSmartPhone'
    }),

    //TODO 設定ボタンで反映するのであればstoreからディープコピーを作成して利用する
    // list
    itemList: {
      get () {
        return this.values
      },
      set (value) {
        this.$set(this, 'values', value)
        this.dragInit = true
      }
    },
    // itemList: {
    //   get () {
    //     console.log('originalValues', this.originalValues)
    //     return this.originalValues
    //   },
    //   set (value) {
    //     this.setValues(value)
    //     // this.setValues({ data: value })
    //     this.dragInit = true
    //   }
    // },

    // validate
    disablePostButton () {
      if (this.filterMode === 0) return false
        return false
    }
  },
  watch: {
    '$route' () {
      // ルーティング変更時にコンポーネントを非表示
      this.hide()
    },
    active (to) {
      if (!to) {
        this.hide()
      }
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      hide: 'sclZIndexModule/hide',
      reset: 'sclZIndexModule/reset',
      setLayer: 'screenConfigLayout/setLayer'
    }),
    ...mapMutations({
      setValues: 'screenConfigLayout/setValues'
    }),

    init () {
      console.log('originalValues', this.originalValues)

      // storeからレイヤー情報のディープコピーを作成
      // this.values = $.extend(true, [], this.originalValues)
      let list = $.extend(true, [], this.originalValues).sort(Utility.sortByKey('zIndex', false))
      this.$set(this, 'values', list)
      console.log('values', this.values)
    },

    getLabel (key) {
      return this.moduleType.filter(item => item.value === key)[0].label
    },

    onMoved (evt) {
      // 変なイベントが発生するマウス対策
      if (this.dragInit && evt.originalEvent.fromElement === null) {
        this.dragInit = false
        return false
      }
    },

    postData () {
      // valuesのzIndexを変更する
      let len = this.values.length
      let data = this.values.map((item, index) => {
        item.zIndex = len - 1 - index
        return item
      })

      // 並べ替えたvaluesをstoreに反映
      this.setValues(data.reverse())

      this.hide()
    },
    
    /**
     * モーダルを閉じる
     */
    closeModal () {
      this.hide()
    }
  }
}